export const PROMPT_LOCALSTORAGE_KEY = "$PROMPT_DATA" as const;
export const AI_COOKIE_KEY = "AI_TOKEN" as const;
